import { Spin } from 'antd';
import { useEffect, useState } from 'react';
import FileViewer from 'react-file-viewer';

const DocumentViewer = ({ fileUrl, fileType }) => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);
    return () => clearTimeout(timer)
  }, []);
  
  return (
    <>
      {loading ? (
        <div className="pdfLoader bg-white w-full flex items-center justify-center">
          <Spin />
        </div>
      ) : (
        <FileViewer
          fileType={fileType}
          filePath={fileUrl}
          errorComponent={() => <div>Error loading file</div>}
          unsupportedComponent={() => <div>Unsupported file type</div>}
        />
      )}
    </>
  );
};

export default DocumentViewer;
